// src/shared/hooks/useApiQuery.ts

import { useQuery, UseQueryOptions, QueryKey } from '@tanstack/react-query';
import { apiRequest } from '@/services/api/api';
import { ApiRequestOptions } from '@/services/api/api.types';

export function useApiQuery<T, P>(
  key: QueryKey,
  url: string,
  method: 'get' | 'post',
  data?: P,
  auth = false,
  requestOptions?: ApiRequestOptions<P>, // Optional request options
  options?: Omit<
    UseQueryOptions<T, Error, T, QueryKey>,
    'queryKey' | 'queryFn'
  >,
) {
  return useQuery<T, Error, T, QueryKey>({
    queryKey: key,
    queryFn: async () => {
      const response = await apiRequest<T, P>(
        method,
        url,
        data,
        auth,
        requestOptions,
      );
      return response.data;
    },
    ...options,
  });
}
